// Types pour l'onboarding B8ild

/**
 * Item de la checklist dashboard
 */
export interface ChecklistItem {
  id: string;
  label: string;
  description: string;
  isCompleted: boolean;
  action?: string; // Route ou action à exécuter
  icon: string;
}

/**
 * État de l'onboarding stocké
 */
export interface OnboardingState {
  isCompleted: boolean;
  completedAt?: string;
}

/**
 * Clé localStorage pour l'onboarding
 */
export const ONBOARDING_STORAGE_KEY = 'b8ild_onboarding_state';
